<template>
    <div>
        <div class="stack-m">
            <label class="field-label stack-xs">Expiration Date</label>
            <div class="grid-fitted grid-unstackable align-items-center">
                <div class="grid-item inline-s">
                    <v-select
                        :options="expMonths"
                        placeholder="Month"
                        v-model="expMonth"
                        :max-height="120"
                        @input="updateMonth"
                        class="card-instrument-expiry-input"/>
                </div>
                <div class="grid-item">
                    <v-select
                        :options="expYears"
                        placeholder="Year"
                        v-model="expYear"
                        :max-height="120"
                        @input="updateYear"
                        class="card-instrument-expiry-input"/>
                </div>
            </div>
        </div>
        <r-button
            size="small"
            class="inline-xs"
            @click="$emit('cancel')">Cancel
        </r-button>
        <r-button
            size="small"
            type="primary"
            @click="update"
            :disabled="!hasChanges">Update
        </r-button>
    </div>
</template>
<script>
    import moment from 'moment';
    import _ from '@/common/helpers';
    import {vSelect} from '@/components/form';

    export default {
        name: 'v-payment-card-expiration-form',
        components: {
            vSelect,
        },
        props: {
            instrument: {
                type: Object,
            },
        },
        data() {
            return {
                expMonths: _.range(1).to(12).map(value => ({value, label: value})),
                expYears: _.range(moment().year()).plus(10).map(value => ({value, label: value})),
                expMonth: +this.instrument.expMonth,
                expYear: +this.instrument.expYear,
            };
        },
        computed: {
            hasChanges() {
                const defaultExpMonth = +this.instrument.expMonth;
                const defaultExpYear = +this.instrument.expYear;
                return this.expMonth !== defaultExpMonth || this.expYear !== defaultExpYear;
            },
        },
        methods: {
            updateMonth(expMonth) {
                this.expMonth = expMonth;
            },
            updateYear(expYear) {
                this.expYear = expYear;
            },
            update() {
                this.$emit('update', {
                    expMonth: this.expMonth,
                    expYear: this.expYear,
                });
            },
        },
    };
</script>
